/**
 * A cláusula de autorização do desconto (E172.F6, E172.F8; ADR-0124 §13, ADR-0126 §5): o que o
 * sistema localizou nas CCBs pelo conteúdo e onde a cláusula está. Espelho à mão dos tipos do
 * servidor (`apps/api/types/clausula_de_autorizacao.py` e `LocalizacaoDaClausula`), reexportado
 * por `formalizacaoAvaliacao`.
 */

type SemProposta = 'nao_localizada' | 'nao_lida' | 'sem_ccb' | 'excede_o_teto' | 'outra_finalidade';
export type SituacaoDaLocalizacao = 'proposta' | SemProposta;
export type CriterioDaLocalizacao = 'titulo' | 'expressao';

export interface ClausulaPropostaData {
  documento_id: string;
  documento: string;
  pagina: number;
  clausula: string | null;
  trecho: string;
  criterio: CriterioDaLocalizacao;
  titulo?: string; // E172.F8: o título como a página o imprime; omitido sem título
  item?: string; // E172.F8: a numeração do item depois do título; omitida sem ela
}

export interface ClausulaPeloMotorData {
  situacao: SituacaoDaLocalizacao;
  proposta: ClausulaPropostaData | null;
  outras: ClausulaPropostaData[];
  nao_lidas: string[];
  excedentes?: string[]; // E172.F6.C02: onde a frase passa do teto; omitido quando vazio
  outra_finalidade?: string[]; // E172.F8: onde está a autorização de outra finalidade e qual é ela
}

/** Onde o perito leu a cláusula de autorização do desconto (E168.F5, AJ-03). */
export interface LocalizacaoDaClausulaData {
  documento: string;
  pagina: number;
  clausula: string | null;
  trecho: string;
  titulo?: string; // E172.F8: o título como a página o imprime; omitido sem ele
  item?: string; // E172.F8: o item logo depois do título; omitido sem ele
}

/** E172.F6 (ADR-0124 §13): sem o limite de 15 palavras; os tetos de segurança do servidor. */
export const TETO_DO_TRECHO = 2000;
export const TETO_DO_DOCUMENTO = 512;
